import ApplicationController from './application_controller'

// import 'easymde/dist/easymde.min.css'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = []

  connect() {
    this.boardId = this.element.dataset.boardId
    this.preview = document.querySelector("#html-export-preview");

    if (this.preview) {
      this.preview.addEventListener("load", () => this.setupLinks());
    }

    this.setupLinks();
  }

  templateSelect() {
    return document.querySelector("#template_name");
  }

  setupLinks() {
    console.log("setup links")
    if (!this.preview) return;
    try {
      var doc = (this.preview.contentDocument) ? this.preview.contentDocument : this.preview.contentWindow?.document;
      if (!doc) return;

      var anchors = doc.getElementsByTagName('a');
      console.log("setup links" + doc)
      for (var i = 0; i < anchors.length; i++) {
        anchors[i].setAttribute('target','_parent');
      }
    } catch (e) {
      console.log("Could not setup links:", e);
    }
  }


  async chooseTemplate(event) {
    event.preventDefault();
    let aElement = event.target.closest('a');
    console.log("chooseTemplate called from " + aElement.id)

    this.getModalController().setViewMode('htmlStyleModal')
    this.getModalController().setTitle(aElement.dataset.bsTitle)
    await this.getModalController().loadHTMLModal('/boards/' + this.boardId + '/html/choose_template')
    // await this.getModalController().hideTitle()
  }

  /* First refresh the HTML preview in the iframe, then update the configuration modal */
  async didChangeTemplate(event) {
    await this.refreshPreview(event);
    await this.getModalController().loadHTMLModal('/boards/' + this.boardId + '/html/choose_template')
  }

  didChangeStyle(event) {
    console.log("did change background-color")
    this.refreshPreview(event);
  }

  /* First save the configuration to the Session via a POST request, then refresh the preview */
  async refreshPreview(event) {
    if (event) {
      event.preventDefault();
    }
    console.log("refresh preview");
    let formElement = document.querySelector('#html-template-form');

    let templateName = "standard";
    if (this.templateSelect() && this.templateSelect().value) {
      templateName = this.templateSelect().value;
    } else if (this.preview && this.preview.src) {
      const match = this.preview.src.match(/\/html\/([^\/\?]+)/);
      if (match) {
        templateName = match[1];
      }
    }

    let templateConfig = {};
    if (formElement) {
      let formData = new FormData(formElement);
      // First, collect all checkbox keys from the form to detect unchecked ones
      let checkboxKeys = new Set();
      for (let element of formElement.elements) {
        if (element.type === 'checkbox') {
          let match = element.name.match(/^template_config\[(.*)\]$/);
          if (match) {
            checkboxKeys.add(element.name);
          }
        }
      }

      for (let [key, value] of formData.entries()) {
        console.log("checking formdate key ", key)
        let match = key.match(/^template_config\[(.*)\]$/);
        if (match) {
          templateConfig[match[1]] = value;
          checkboxKeys.delete(key);
        } else if (key === 'template_name') {
          templateName = value;
        }
      }

      // Add unchecked checkboxes as "off"
      for (let key of checkboxKeys) {
        let match = key.match(/^template_config\[(.*)\]$/);
        if (match) {
          templateConfig[match[1]] = 'off';
        }
      }

    }
    console.log(templateConfig)
    let url = `/boards/${this.boardId}/html/update_preview_config`;
    let body = JSON.stringify({
      authenticity_token: this.getCsrfToken(),
      template_name: templateName,
      template_config: templateConfig
    });

    await this.doFetch(url, "POST", body);

    if (this.preview) {
      let newSrc = `/boards/${this.boardId}/html?t=${Date.now()}`;
      this.preview.src = newSrc;
      this.setupLinks();
    }

    return true;
  }

  exportHtml (event) {
    event.preventDefault();
    console.log("push HTML download");
    this.pushDownload();
  }

  async pushDownload () {
    const htmldata = await this.loadHtml();
    var blob = new Blob([htmldata.html], {type: "text/plain;charset=utf-8"});
    await saveAs(blob, htmldata.title + ".html");
  }

  async loadHtml () {
    let boardid = this.element.dataset.boardId;
    let csrf_tag = document.querySelector('meta[name="csrf-token"]');
    let url = "/boards/" + boardid + "/html";
    let method = "POST";

    let templateName = "standard";
    if (this.templateSelect() && this.templateSelect().value) {
      templateName = this.templateSelect().value;
    } else if (this.preview && this.preview.src) {
      const match = this.preview.src.match(/\/html\/([^\/\?]+)/);
      if (match) {
        templateName = match[1];
      }
    }

    let raw_body = {
      template_name: templateName,
      remote: true
    }
    let headers = {
      "Content-Type": "application/json",
      // "Accept": "text/html",
      'X-Requested-With': 'XMLHttpRequest'
    }

    if(csrf_tag != undefined && csrf_tag.content != undefined) {
      let csrf_token = document.querySelector('meta[name="csrf-token"]').content
      raw_body.authenticity_token = csrf_token
      headers['authenticity_token'] = csrf_token
    }
    let body = JSON.stringify(raw_body);

    const response = await this.doFetch (url, method, body, headers);
    const raw_string = await response.text();
    const html = this.htmlDecode(raw_string)
    var filename = "standardfilename";

    if(html.match(/(?:<h1.*>)(.*)<\/h1>/m)) {
      filename = html.match(/(?:<h1.*>)(.*)<\/h1>/m)[1];
    }

    let htmldata = {
      "title": filename.trim(),
      "html": html
    };
    return htmldata
  }
  htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }
}
